import apiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getTenantCounts = (token, from, to) => {
    return fetch(`${apiUrl}tenant_counts?${from ? '&from=' + from : ""}${to ? "&to=" + to : ""}`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}

export default getTenantCounts